import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  CreateNeedFormDialog,
  CreateNeedFormDialogCallbackInput,
  CreateNeedFormDialogUniqueProps,
} from '../create-need-form-dialog';

const { useDialogForContext, useDialog: useFormDialog } = getDialogHooks<
  CreateNeedFormDialogUniqueProps,
  CreateNeedFormDialogCallbackInput
>(CreateNeedFormDialog);
export const useCreateNeedFormDialogForContext = useDialogForContext;
export default useFormDialog;
